import { InjectionKey, Ref } from 'vue';

export type UserClaimsProvide = Ref<{ type: string; value: string | number }[]>;

interface AppLayoutProvide {
    registerError: (error: Error) => void;
}

export const UserClaimsKey: InjectionKey<UserClaimsProvide> = Symbol.for('kolumbus:userClaims');

export const AppLayoutProvideKey: InjectionKey<AppLayoutProvide> = Symbol.for('app:layout');
